import * as React from "react";
import { BigCharacter } from "../generic/big-character/BigCharacter";
import { IdBigCharacter } from "../generic/big-character/IdBigCharacter";
export var LevelUpCharacters = function () {
    var characterRita = (React.createElement(BigCharacter, { name: IdBigCharacter.RitaHappy, className: "level-up_character-size flex__auto" }));
    var characterGeorge = (React.createElement(BigCharacter, { name: IdBigCharacter.GeorgeHappy, className: "level-up_character-size flex__auto" }));
    var characterMonica = (React.createElement(BigCharacter, { name: IdBigCharacter.Monica, className: "level-up_character-size flex__auto" }));
    var characterTessaHappy = (React.createElement(BigCharacter, { name: IdBigCharacter.TessaHappy, className: "level-up_character-size flex__auto" }));
    return (React.createElement("div", { className: "level-up__characters" },
        React.createElement("div", { className: "level-up__characters-container" },
            React.createElement("div", { className: "level-up_character level-up_character-left" },
                characterRita,
                characterGeorge),
            React.createElement("div", { className: "level-up_character level-up_character-right" },
                characterTessaHappy,
                characterMonica))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/xp/LevelUpCharacters.tsx
// module id = 2559
// module chunks = 3